export const getBadgeDetailsFormConfig = (t) => ({
    type: 'form',
    children: [
        {
            type: 'form.text',
            key: 'badgeDocumentName',
            label: t('badges.create.wizard.step1.labelDocumentName'),
            validate: {
                required: true,
            },
        },
        {
            type: 'form.text',
            key: 'badgeDescription',
            label: t('badges.create.wizard.step1.labelDescription'),
            multiline: true,
            rows: 4,
        },
    ],
});
